import { Route, Routes } from 'react-router-dom'
import SchedulingCourseSessions from './CourseSessions'
import SchedulingCourses from './Courses'
import SchedulingTabs, { tabConfig } from './Tabs'
import { BasePathProvider } from 'components/Providers'
import SchedulingEnrollStudent from './EnrollStudent'
import SchedulingEnrollCourse from './EnrollCourse'
import ReportCard from './ReportCard'
import { Box, Paper } from '@mui/material'
import PageHeader from 'components/AppBar/PageHeader'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import NotFound from 'components/NotFound'
import Protected from 'components/Protected'

export default function Scheduling() {
  const basePath = '/scheduling'

  return (
    <BasePathProvider value={`${basePath}/`}>
      <Box sx={{ pb: 2 }}>
        <PageHeader title={'Scheduling'} />
      </Box>
      <Paper sx={{ minHeight: '500px', p: 2, mb: 2 }}>
        <SchedulingTabs />
        <Routes>
          <Route path="/">
            <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
            <Route path="/courses/*" element={<Protected permission="scheduling.course"><SchedulingCourses /></Protected>} />
            <Route path="/course-sessions/*" element={<Protected permission="scheduling.session"><SchedulingCourseSessions /></Protected>} />
            <Route path="/enroll-student/*" element={<Protected permission="scheduling.enroll"><SchedulingEnrollStudent /></Protected>} />
            <Route path="/enroll-session/*" element={<Protected permission="scheduling.enroll"><SchedulingEnrollCourse /></Protected>} />
            <Route path="/report-card/*" element={<Protected permission="scheduling.report"><ReportCard /></Protected>} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Paper>
    </BasePathProvider>
  )
}
